import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {AbstractStyleComponent} from '../abstract-style/abstract-style.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';


@Component({
  selector: 'app-color',
  imports: [
    ReactiveFormsModule,
    FormsModule
],
  templateUrl: './color.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './color.component.scss'
})
export class ColorComponent extends AbstractStyleComponent {
  color: string | null = null;
  opacity: number | null = null;
  enabled: boolean = false;
  @Input() opacityEnabled: boolean = false;

  getValue(): any {
    if (this.enabled) {
      if (!this.isValidColor(this.color)) {
        this.color = '#000000';
      }

      let color = this.color;

      if (this.opacityEnabled) {
        let opacity = ((this.opacity ?? 100) / 100.0) * 255;
        opacity = Math.round(Math.max(Math.min(opacity, 255), 0));
        color += opacity.toString(16);
      }

      return color;
    }

    return null;
  }

  setValue(value: any): void {
    if (this.isValidColor(value)) {
      const result = value.match(/^#([0-9a-fA-F]{6})([0-9a-fA-F]{2})?$/)

      this.color = '#' + result[1];
      this.opacity = 100;

      if (result[2] !== undefined) {
        this.opacity = Math.round((parseInt(result[2], 16) / 256) * 100);
      }

      this.enabled = true;
    } else {
      this.color = null;
      this.enabled = false;
    }
  }

  getPreviewOpacity(): number {
    if (this.opacityEnabled) {
      return (this.opacity ?? 100) / 100.0;
    }

    return 1;
  }
}
